export enum MarketSegmentType {
    Individual = 1,
    Group = 2,
    LargeGroup = 3
  }